<template>
	<Modal @close="$emit('close')" class="delete-task" ref="deleteModal" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<h3>Delete {{ task.name }}</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<p>The selected task will be deleted from the application permanently.</p>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<button class="button-action button-action-delete" @click="deleteTask">Delete</button>
					<button class="button-action button-action-cancel" @click="$refs.deleteModal.close()">Cancel</button>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'

export default {
  components: {
		Modal
	},
	props: [
		'task'
	],
	methods: {
		deleteTask() {
			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`tasks/delete`, this.task)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `Task ${this.task.name} Deleted`,
					timeout: 3000
				})
				this.$emit('close')
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Tasks/Delete.vue